import { connect } from 'react-redux'

import EcgLoader from './EcgLoader'

const mapActionCreators = {
}

const mapStateToProps = state => ({
  browser: state.app.browser,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(EcgLoader)



// WEBPACK FOOTER //
// ./src/legacy/containers/EcgLoader/container.jsx